URLSearchParams.prototype.deleteMany = function (keys) {
    for (let key of keys) {
        this.delete(key);
    }
};
URLSearchParams.prototype.deleteEmpty = function () {
    const toDelete = [];
    for (let [key, val] of this.entries()) {
        if (val === "") {
            toDelete.push(key);
        }
    }
    this.deleteMany(toDelete);
};
String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
}

String.prototype.truncate = function (length) {
    return this.length > length ? this.substring(0, length) + "..." : this;
}

String.prototype.replaceAll = function (search, replacement) {
    return this.split(search).join(replacement);
}

Array.prototype.unique = function () {
    return [...new Set(this)];
}

Array.prototype.remove = function (value) {
    return this.filter(function (ele) {
        return ele !== value;
    });
}

Array.prototype.removeAt = function (index) {
    return this.filter(function (ele, i) {
        return i !== index;
    });
}
String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
};
String.prototype.truncate = function (length) {
    return this.length > length ? this.substring(0, length) + "..." : this;
};
String.prototype.replaceAll = function (search, replacement) {
    return this.split(search).join(replacement);
};
Array.prototype.unique = function () {
    return [...new Set(this)];
};
Array.prototype.remove = function (value) {
    return this.filter(function (ele) {
        return ele !== value;
    });
};
Array.prototype.removeAt = function (index) {
    return this.filter(function (ele, i) {
        return i !== index;
    });
};
Array.prototype.removeDuplicates = function () {
    return this.filter(function (item, index, self) {
        return self.indexOf(item) === index;
    });
};
Array.prototype.removeEmpty = function () {
    return this.filter(function (item) {
        return item !== "";
    });
};
Array.prototype.removeFalsy = function () {
    return this.filter(function (item) {
        return item;
    });
};
Array.prototype.removeNull = function () {
    return this.filter(function (item) {
        return item !== null;
    });
};
Array.prototype.removeUndefined = function () {
    return this.filter(function (item) {
        return item !== undefined;
    });
};
Array.prototype.removeFalse = function () {
    return this.filter(function (item) {
        return item !== false;
    });
};
Array.prototype.removeZero = function () {
    return this.filter(function (item) {
        return item !== 0;
    });
};
Array.prototype.removeNaN = function () {
    return this.filter(function (item) {
        return !isNaN(item);
    });
};
import Blockly from 'blockly/core';
